import { z } from 'zod';

export const TextureSetSchema = z.object({
  front: z.string().optional(), // FIXME: remove .optional()
  back: z.string().optional(), // FIXME: remove .optional()
  left: z.string().optional(), // FIXME: remove .optional()
  right: z.string().optional(), // FIXME: remove .optional()
  top: z.string().optional(), // FIXME: remove .optional()
});

export type TextureSet = z.infer<typeof TextureSetSchema>;

export const Dimensions2DSchema = z.object({
  width: z.number(),
  height: z.number(),
});

export type Dimensions2D = z.infer<typeof Dimensions2DSchema>;

export const Dimensions3DSchema = z.object({
  width: z.number(),
  height: z.number(),
  depth: z.number(),
});

export type Dimensions3D = z.infer<typeof Dimensions3DSchema>;

export const Vector3Schema = z.object({
  x: z.number(),
  y: z.number(),
  z: z.number(),
});

export type Vector3 = z.infer<typeof Vector3Schema>;

export const PositionableSchema = z.object({
  uid: z.string(),
  position: Vector3Schema,
  rotation: Vector3Schema,
  dimensionsOverride: Dimensions3DSchema.optional(),
});

export type Positionable = z.infer<typeof PositionableSchema>;

export const RackStringSchema = PositionableSchema;
export type RackString = z.infer<typeof RackStringSchema>;

export const RackSchema = PositionableSchema;
export type Rack = z.infer<typeof RackSchema>;

export const ModuleSchema = PositionableSchema;
export type Module = z.infer<typeof ModuleSchema>;

export const DoorSchema = PositionableSchema;
export type Door = z.infer<typeof DoorSchema>;

export const VentSchema = PositionableSchema;
export type Vent = z.infer<typeof VentSchema>;

export const ConnectionSchema = z.object({
  uid: z.string(),
  pcs: z.string(),
  containers: z.array(z.string()),
  diameterOverride: z.number().optional(),
});
export type Connection = z.infer<typeof ConnectionSchema>;

export const PCSSchema = PositionableSchema.extend({
  label: z.string().optional(),
  textureOverride: TextureSetSchema.optional(),
  doors: z.array(DoorSchema).optional(),
});
export type PCS = z.infer<typeof PCSSchema>;

export const ContainerSchema = PositionableSchema.extend({
  rackStrings: z.array(RackStringSchema).optional(),
  label: z.string().optional(),
  racks: z.array(RackSchema).optional(),
  modules: z.array(ModuleSchema).optional(),
  textureOverride: TextureSetSchema.optional(),
  doors: z.array(DoorSchema).optional(),
  vents: z.array(VentSchema).optional(),
});
export type Container = z.infer<typeof ContainerSchema>;

export const TexturesSchema = z.object({
  BESS: TextureSetSchema.optional(),
  PCS: TextureSetSchema.optional(),
});
export type Textures = z.infer<typeof TexturesSchema>;

export const DimensionsSchema = z.object({
  Landscape: Dimensions2DSchema.optional(), // FIXME: remove .optional()
  BESS: Dimensions3DSchema.optional(), // FIXME: remove .optional()
  String: Dimensions3DSchema.optional(), // FIXME: remove .optional()
  PCS: Dimensions3DSchema.optional(),
  Rack: Dimensions3DSchema.optional(),
  Vent: Dimensions3DSchema.optional(),
  Module: Dimensions3DSchema.optional(),
  PCSDoor: Dimensions3DSchema.optional(),
  BESSDoor: Dimensions3DSchema.optional(),
  ConnectionDiameter: z.number().optional(),
});
export type Dimensions = z.infer<typeof DimensionsSchema>;

export const SpecificationsSchema = z.object({
  dimensions: DimensionsSchema,
  textures: TexturesSchema.optional(),
});
export type Specifications = z.infer<typeof SpecificationsSchema>;

export const SkyboxSchema = z.object({
  front: z.string(),
  back: z.string(),
  left: z.string(),
  right: z.string(),
  top: z.string(),
  bottom: z.string(),
});
export type Skybox = z.infer<typeof SkyboxSchema>;

export const BackgroundSchema = z.object({
  skybox: SkyboxSchema.optional(),
  sphere_skybox: z.string().optional(),
  color: z.string().optional(),
  image: z.string().optional(),
});
export type Background = z.infer<typeof BackgroundSchema>;

export const LandscapeSchema = z.object({
  backgroundImageSatellite: z.string().optional(),
  backgroundImageAbstract: z.string().optional(),
});
export type Landscape = z.infer<typeof LandscapeSchema>;

export const StaticDataSchema = z.object({
  landscape: LandscapeSchema,
  background: BackgroundSchema.optional(),
  specifications: SpecificationsSchema,
  containers: z.array(ContainerSchema),
  pcs: z.array(PCSSchema).optional(),
  connections: z.array(ConnectionSchema).optional(),
});

/**
 * INFO:
 * For the moment, webapp doesn't transform staticData and passes the value as is to @accure/siteview
 * There is then no point to define a different local entities, then we just reuse TStaticData
 */
export type StaticData = z.infer<typeof StaticDataSchema>;
